import React from "react";

const Razor_VB_Variables = () => {
  return (
    <div className="tutorial-page">
      <h1>Razor VB Variables</h1>
      <p>This is the Razor VB Variables page content.</p>
    </div>
  );
};

export default Razor_VB_Variables;
